import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const TARGET = new Date("2027-02-19T09:00:00+05:30").getTime();

function getParts() {
  const diff = Math.max(0, TARGET - Date.now());
  const totalSeconds = Math.floor(diff / 1000);
  const months = Math.floor(totalSeconds / (30.44 * 24 * 3600));
  const days = Math.floor((totalSeconds - months * 30.44 * 24 * 3600) / (24 * 3600));
  const hours = Math.floor((totalSeconds % (24 * 3600)) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return { months, days, hours, minutes, seconds };
}

const UNITS = [
  ["months", "Months"],
  ["days", "Days"],
  ["hours", "Hrs"],
  ["minutes", "Min"],
  ["seconds", "Sec"],
];

export default function Countdown() {
  const [t, setT] = useState(getParts);

  useEffect(() => {
    const id = setInterval(() => setT(getParts()), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7, delay: 1.15, ease: [0.22, 1, 0.36, 1] }}
      className="mt-10 inline-flex flex-col gap-3"
      data-testid="season-countdown"
    >
      <span className="text-[10px] font-bold uppercase tracking-[0.3em] text-white/60">
        Season 6.0 begins in — 19 Feb 2027
      </span>
      <div className="flex gap-2.5 sm:gap-3">
        {UNITS.map(([key, label]) => (
          <div
            key={key}
            className="backdrop-blur-xl bg-white/10 border border-white/20 rounded-xl px-3 sm:px-4 py-3 min-w-[64px] sm:min-w-[72px] text-center"
            data-testid={`countdown-${key}`}
          >
            <span className="block font-oswald text-3xl sm:text-4xl font-semibold text-white leading-none tabular-nums">
              {String(t[key]).padStart(2, "0")}
            </span>
            <span className="block text-[9px] font-bold uppercase tracking-[0.2em] text-white/50 mt-1.5">{label}</span>
          </div>
        ))}
      </div>
    </motion.div>
  );
}
